import * as CookieConsent from 'vanilla-cookieconsent';

/**
 * Add one category to the visitor's current choice. Never call
 * `CookieConsent.acceptCategory('x')` with a single category directly: that accepts ONLY
 * x and revokes everything else — a visitor who allowed statistics and then unblocks a
 * form or video would silently lose the statistics consent.
 */
export function acceptAlso(category: string): void {
  const prefs = CookieConsent.getUserPreferences();
  const accepted: string[] = (prefs && prefs.acceptedCategories) || [];
  if (accepted.indexOf(category) === -1) {
    CookieConsent.acceptCategory([...accepted, category]);
  }
}
